// Ajax cart JS for Drawer and Cart Page
const drawerSelectors = {
  cartIcons: document.querySelectorAll('.header__icon--cart'),
  cartIconDesktop: document.querySelector('#cart-icon-desktop'),
  cartIconMobile: document.querySelector('#cart-icon-mobile'),
  cartCloseBtn: document.querySelector('.close-ajax--cart'),
  cartTotal: document.querySelector('#ajax-cart [data-cart-total]')
};

class AjaxCart extends HTMLElement {
    constructor() {
      super();
  
      this.openeBy = drawerSelectors.cartIcons;
      this.isOpen =  this.classList.contains('open--drawer');
      this.cartForm = this.querySelector('form');
      this.sectionID = 'component-cart-drawer';
      this.enableUpdate = false;
      // alert('load page')
      // if(window.globalVariables.templateSuffix != "quick-order"){
      this.loadSavedCartProducts();
      // }

      if(window.globalVariables.template == 'cart'){
        this.style.visibility = 'visible';
        this.sectionID = document.getElementById('cart--items').dataset.id;
      }else{
        this.addAccessibilityAttributes(this.openeBy);
        this.getCartData();
      }

      if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

      
      if(window.globalVariables.customer_email != null){
        //if(document.querySelector('[data-currentlocations]')){
            this.addLocationAttributes()
       // }
      }

      this.checkForAdditional();
    }

    checkForAdditional(){
      if(document.getElementById('clearcartforadditional')){
        if(document.getElementById('clearcartforadditional').value == 'true' || document.getElementById('clearcartforadditional').value == true){
          let linedata = document.getElementById('clearcartforadditional').getAttribute('data-line')
          this.updateItemQty(linedata, 0);
        }
      }
    }

    addLocationAttributes(){
      var formData = new FormData();

      let cookieWarehouse = document.querySelector('[data-currentlocations]').getAttribute('data-currentlocations');
      let mainHeaderIdArray = document.querySelector('[data-currentlocations]').getAttribute('data-currentlocations').split(',');
      let mainlocation = document.querySelector('[data-currentselectedaddress]').getAttribute('data-currentselectedaddress');
      let shippingAddress1 = document.querySelector('[data-currentSelectedShippingAddress1]').getAttribute('data-currentSelectedShippingAddress1');
      let shippingAddress2 = document.querySelector('[data-currentSelectedShippingAddress2]').getAttribute('data-currentSelectedShippingAddress2');
      let shippingCity = document.querySelector('[data-currentSelectedShippingCity]').getAttribute('data-currentSelectedShippingCity');
      let shippingProvince = document.querySelector('[data-currentSelectedShippingProvince]').getAttribute('data-currentSelectedShippingProvince');
      let shippingZip = document.querySelector('[data-currentSelectedShippingZip]').getAttribute('data-currentSelectedShippingZip');

      // Trim each component and filter out empty values, then join with comma
      let shippingAddressParts = [
        shippingAddress1?.trim(),
        shippingAddress2?.trim(),
        shippingCity?.trim(),
        shippingProvince?.trim(),
        shippingZip?.trim()
      ].filter(part => part && part !== ''); // Remove empty/blank parts
      
      let shippingAddress = shippingAddressParts.join(', ');
      let getIndexWarehouse = mainHeaderIdArray.indexOf(cookieWarehouse);

      
      let shipTo = document.querySelector('[data-metashipto]').getAttribute('data-metashipto');

    
      if(window.globalVariables.cart.item_count > 0){
        formData.append("attributes[Ship Location]", mainlocation);
        formData.append("attributes[Shipping Address]", shippingAddress);
        formData.append("attributes[Ship to ID]", shipTo);
        formData.append("attributes[Location ID]", cookieWarehouse);
      }else{
        formData.append("attributes[Ship Location]", '');
        formData.append("attributes[Shipping Address 1]", '');
        formData.append("attributes[Ship to ID]", '');
        formData.append("attributes[Location ID]", '');
      }

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => console.log())
      .catch((e) => {
        console.error(e);
        // Rollbar.error(`File: component-cart-form.js, getting error on addLocationAttributes: ${e}`);
      });
    }
  
    connectedCallback() {
      this.bindEvents();
      this.cartNoteInput();
    }

    async loadSavedCartProducts(){
      /* START :: savecart functionality to auto add products */
      let websiteType = Utility.getCookie('websiteType');
      let locationID = Utility.getCookie('locationID');
      // console.log('websiteType',websiteType);
      

      /*
        locationID is written by component-location-popup.js only after its get-locations
        request resolves, so on the first load of a session it is not there yet - hence the
        poll. It used to run forever: the branch where currentLocation already equals
        locationID never cleared the interval, so every page kept a 500ms timer alive and
        filled the console for the life of the tab. Now the poll stops as soon as locationID
        is readable, and gives up after maxLocationChecks if it never arrives (a customer
        whose tags match no warehouse never gets one).
      */
      let locationChecks = 0;
      const maxLocationChecks = 20; // 10s, get-locations answers in well under 1s
      const checkCurrentLocationInterval = setInterval(async () => {
        locationID = Utility.getCookie('locationID');
        const currentLocation = Utility.getCookie('currentLocation');

        if (!locationID) {
          locationChecks += 1;
          if (locationChecks >= maxLocationChecks) clearInterval(checkCurrentLocationInterval);
          return;
        }

        clearInterval(checkCurrentLocationInterval);

        if (!currentLocation) {
          // First location of the session - there is no previous cart to swap out.
          Utility.setCookie('currentLocation', locationID, 1);
          return;
        }
        if (currentLocation == locationID) return;

        // Only record the new location once its cart is actually in place, so a failed
        // swap is retried on the next page load instead of being silently skipped.
        if (await cartAPIs()) Utility.setCookie('currentLocation', locationID, 1);
      }, 500);

      /**
       * Swap the Shopify cart for the one saved against the current location.
       *
       * @return {Promise<Boolean>} true when the cart now reflects the new location
       */
      async function cartAPIs(){
        let currentLocationID = Utility.getCookie('locationID');
        let currentWebsiteType = Utility.getCookie('websiteType');

        // Retry mechanism for locationID
        let retryCount = 0;
        const maxRetries = 10; // Maximum 10 retries (5 seconds total)

        while ((!currentLocationID || currentLocationID.trim() === '') && retryCount < maxRetries) {
          await new Promise(resolve => setTimeout(resolve, 500)); // Wait 500ms
          currentLocationID = Utility.getCookie('locationID');
          currentWebsiteType = Utility.getCookie('websiteType');
          retryCount++;
        }

        if (!currentLocationID || currentLocationID.trim() === '') return false;
        if (!currentWebsiteType || !window.globalVariables.customer_id) return false;

        /*
          Read the new location's cart BEFORE emptying the current one.

          This used to clear first and fetch second. When the lookup then failed - the
          backend down, or the network dropping mid-swap - the customer was left with an
          empty cart and nothing to restore from, and currentLocation had already been
          advanced by the caller, so the next page load saw no change left to act on and
          never retried. Returning false before anything is cleared leaves both the cart
          and the cookie as they were, and the next load tries again.
        */
        let savedCart;
        try {
          const savedResponse = await fetch(`https://shopifyapi2.jinny.com/api/get-cart/${currentLocationID}/${currentWebsiteType}/${window.globalVariables.customer_id}`);
          if (!savedResponse.ok) throw new Error(`HTTP error! status: ${savedResponse.status}`);
          savedCart = (await savedResponse.json()).cart;
        } catch (error) {
          console.error('Error fetching saved cart:', error);
          return false;
        }

        // The API answers [] - not an empty cart object - for a location with nothing saved.
        const savedItems = Array.isArray(savedCart) ? [] : (savedCart?.items ?? []);

        try {
          const response = await fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
          });
          if (!response.ok) {
            console.error('Failed to clear the cart:', response.statusText);
            return false;
          }
          window.globalVariables.cart.item_count = 0;
        } catch (error) {
          console.error('Error clearing the cart:', error);
          return false;
        }

        if (savedItems.length > 0) {
          // The cart is empty at this point, so a failed re-add is the same loss the
          // reordering above guards against: report it and let the next load redo the swap.
          try {
            const addResponse = await fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                items: savedItems.map(({ id, quantity, properties }) => ({ id, quantity, properties }))
              })
            });
            if (!addResponse.ok) throw new Error(`HTTP error! status: ${addResponse.status}`);
          } catch (error) {
            window.Rollbar?.error(`File: component-cart-form.js, getting error on loadSavedCartProducts: ${error}`);
            document.querySelector('cart-form')?.getCartData();
            return false;
          }
        }

        // getCartData's argument lands in `action` (only 'open_drawer' means anything) - it
        // never reaches the `cartaction` that saves to the backend, so pass nothing.
        document.querySelector('cart-form')?.getCartData();
        return true;
      }


      if(Utility.getCookie('savecustomer') != window.globalVariables.customer_email){
        // Utility.removeCookie(`savecart_dreamworld`);
        // Utility.removeCookie(`savecart_urbanbeauty`);
        // Utility.removeCookie(`savecart_barberunited`);
        let requestData = {
          "customerId": window.globalVariables.customer_id,
          "cartType": websiteType,
          "location_id": locationID,
          "data": {}
        };
     
        try {
          const response = await fetch("https://shopifyapi2.jinny.com/api/update-cart", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify(requestData),
          });
          const responseData = await response.json();
        } catch (e) {
          console.error(e);
          // Rollbar.error(`File: component-product-form.js, getting error in fetch inventory on onVariantChange: ${e}`);
        }

        // Fetch saved cart data from API
      
      }

      

      // if(Utility.getCookie(`savecart_${websiteType}`) != ''){
      //   let currentSavedCartValue = JSON.parse(Utility.getCookie(`savecart_${websiteType}`));
      //   if(window.globalVariables.cart.item_count == 0){
      //     if(currentSavedCartValue.item_count > 0){
      //       let formData = {};
      //       let items = [];
      //       currentSavedCartValue.items.forEach(item => {
      //         let id = item.id;
      //         let quantity = item.quantity;
      //         let properties = item.properties;
      //         items.push({
      //           id,
      //           quantity,
      //           properties
      //         })    

      //       });
      //       formData = { items };
      //       fetch(window.Shopify.routes.root + 'cart/add.js', {
      //         method: 'POST',
      //         headers: {
      //           'Content-Type': 'application/json'
      //         },
      //         body: JSON.stringify(formData)
      //       })
      //       .then(response => {
      //         return response.json();
      //       })
      //       .catch((error) => {
      //         console.error('Error:', error);
      //         Rollbar.error(`File: component-cart-form.js, getting error on loadSavedCartProducts: ${error}`);
      //       }).finally(() => {
      //         this.getCartData();
      //       });
      //     }
      //   }

      // }
/* END :: savecart functionality to auto add products */
    }

    /**
     * Observe attribute of component
     * 
     * @returns {array} Attributes to Observe
     */
    static get observedAttributes() {
      return ['updating'];
    }
  
    /**
     * To Perform operation when attribute is changed
     * Calls attributeChangedCallback() with params when attribute value is updated
     * 
     * @param {string} name attribute name
     * @param {string} oldValue attribute Old value
     * @param {string} newValue attribute latest value
     */
    attributeChangedCallback(name, _oldValue, newValue) {
      // called when one of attributes listed above is modified
      if(name === 'updating' && newValue === 'false'){
        this.updateEvents();
      }
    }
  
    /**
     * Add accessibility attributes to Open Drawer buttons
     * 
     * @param {Node Array} openDrawerButtons Cart Icons
     */
    addAccessibilityAttributes(openDrawerButtons) {
      let _this = this;
      openDrawerButtons.forEach(element => {
        element.setAttribute('role', 'button');
        element.setAttribute('aria-expanded', false);
        element.setAttribute('aria-controls', _this.id);
      });
    }
  
    /**
     * Escape Click event to close drawer when focused within Cart Drawer
     *
     * @param {event} Event instance
     */
    onKeyUp(event) {
      if(event.code.toUpperCase() !== 'ESCAPE') return;
      drawerSelectors.cartCloseBtn.dispatchEvent(new Event('click'));
    }
  
    /**
     * bind dclick and keyup event to Cart Icons
     * bind keyUp event to Cart drawer component
     * bind Other inside element events
     *
     */
    bindEvents() {
      if(window.globalVariables.template !== 'cart'){
        this.openeBy.forEach(cartBtn => cartBtn.addEventListener('click', this.openCartDrawer.bind(this)));
        this.addEventListener('keyup', this.onKeyUp.bind(this));
        drawerSelectors.cartCloseBtn.addEventListener('click', this.closeCartDrawer.bind(this));
      }
      this.updateEvents();
    }

    /**
     * bind Other inside element events to DOM
     *
     */
    updateEvents(){
      this.querySelectorAll('[data-item-remove]').forEach(button => button.addEventListener('click', this.removeItem.bind(this)));
      this.querySelectorAll('[data-qty-btn], [data-update-bulk-qty]').forEach(button => button.addEventListener('click', this.manageQtyBtn.bind(this)));
      this.querySelectorAll('[data-qty-input]').forEach(button => button.addEventListener('change', this.onQtyChange.bind(this)));
      
      // Add checkout button click handler
      const checkoutBtns = this.querySelectorAll('[data-checkout-btn]');
      // console.log('Found checkout buttons:', checkoutBtns.length);
      
      checkoutBtns.forEach((checkoutBtn, index) => {
        // console.log(`Binding checkout button ${index}:`, checkoutBtn);
        // Remove existing listener to prevent duplicates
        checkoutBtn.removeEventListener('click', this.handleCheckoutClick.bind(this));
        // Add new listener
        checkoutBtn.addEventListener('click', this.handleCheckoutClick.bind(this));
        // console.log(`Checkout button ${index} bound successfully`);
      });
    }
  
    /**
     * Open Cart drawer and add focus to drawer container
     *
     * @param {event} Event instance
     */
    openCartDrawer(event) {
      if(!window.globalVariables.cart_drawer || window.globalVariables.templateSuffix === 'quick-order'){
        window.location.href = window.routes.cart_fetch_url || '/cart';
        return;
      }
  
      if(document.querySelector('#mobile-menu-drawer').classList.contains('opened-drawer')){
        document.querySelector('.close-mobile--navbar').dispatchEvent(new Event('click'));
      }
  
      this.classList.add('opened-drawer');
      siteOverlay.prototype.showOverlay();
      Utility.forceFocus(this.querySelector('.cart-title'));
      Utility.trapFocus(this, drawerSelectors.cartCloseBtn);
  
      if(event){
        event.preventDefault();
        let openBy = event.currentTarget;
        openBy.setAttribute('aria-expanded', true);
      }
    }
  
    /**
     * Close Cart drawer and Remove focus from drawer container
     *
     * @param {event} Event instance
     */
    closeCartDrawer(event, elementToFocus = false) {
      if (event == undefined) return;

      event.preventDefault();
      this.classList.remove('opened-drawer');
      siteOverlay.prototype.hideOverlay();

      let openByEle = event.currentTarget;
      openByEle.setAttribute('aria-expanded', false);
      Utility.removeTrapFocus(elementToFocus);

      let actionBtn = drawerSelectors.cartIconDesktop;
      if(window.innerWidth < 1024){
        actionBtn = drawerSelectors.cartIconMobile;
      }
      Utility.forceFocus(actionBtn);
    }
  
    /**
     * Update cart HTML and Trigger Open Drawer event
     *
     * @param {string} cartHTML String formatted response from fetch cart.js call
     * @param {string} action Open Drawer as value if need to Open Cart drawer
     */
    _updateCart(response, action,cartaction){
      if(response === null) return;

      this.setAttribute('updating', true);
      // Convert the HTML string into a document object
      let cartHTML = response[this.sectionID];
      let parser = new DOMParser();
      cartHTML = parser.parseFromString(cartHTML, 'text/html');

      let cartJSONEle = cartHTML.querySelector('[data-cartScriptJSON]');
      window.globalVariables.cart = JSON.parse(cartJSONEle.textContent);

      // START :: SAVED CART FUNCTIONALITY ::Store value to cookie for saved cart
      if(cartaction == 'updateCart'){
       
        
        let websiteName = Utility.getCookie('websiteType');
        let locationID = Utility.getCookie('locationID');
        let cartItems = window.globalVariables.cart.items;
        let items = []
        cartItems.forEach(item => {
          let id = item.id;
          let quantity = item.quantity;
          let properties = item.properties;
          items.push({
            id,
            quantity,
            properties
          })
        });
        let newvalue = {
          "note": window.globalVariables.cart.note,
          "attributes": window.globalVariables.cart.attributes,
          "item_count": window.globalVariables.cart.item_count,
          "original_total_price": window.globalVariables.cart.original_total_price,
          items
        }


        
        // Utility.removeCookie(`savecart_${websiteName}`); 
        // let cartVal = JSON.stringify(window.globalVariables.cart).replace(/\\n/g, "\\n")
        // .replace(/\\'/g, "\\'")
        // .replace(/\\"/g, '\\"')
        // .replace(/\\&/g, "\\&")
        // .replace(/\\r/g, "\\r")
        // .replace(/\\t/g, "\\t")
        // .replace(/\\b/g, "\\b")
        // .replace('&quot;',"")
        // .replace(/\\f/g, "\\f");

        
        // setTimeout(function(){
        let requestData = {
          "customerId": window.globalVariables.customer_id,
          "cartType": websiteName,
          "location_id": locationID,
          "data": newvalue
        };
        // return false;
        fetch("https://shopifyapi2.jinny.com/api/update-cart", {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          },
          body: JSON.stringify(requestData),
          }).then(response => {
            return response.json();
          }).then(response => {
            // console.log('response savecart',response);
          }).catch((e) => {
            console.error(e);
            // Rollbar.error(`File: component-product-form.js, getting error in fetch inventory on onVariantChange: ${e}`);
          })
        // return false;
          // Utility.setCookie(`savecart_${websiteName}`, JSON.stringify(newvalue), 7);
          
          Utility.setCookie(`savecustomer`,window.globalVariables.customer_email, 7) 
        // },1000);
        
       
       
      }
      // END :: Store value to cookie for saved cart

      let cartElement = cartHTML.querySelector('form');
      this.cartForm.innerHTML = cartElement.innerHTML;

      let additionalprice = 0;
      if(cartHTML.querySelector('[data-additionalprice]')){
        additionalprice = cartHTML.querySelector('[data-additionalprice]').getAttribute('data-additionalprice');
      }
      let c_t = parseInt(window.globalVariables.cart.total_price) - parseInt(additionalprice);

      let cartTotal = Utility.formatMoney(c_t, window.globalVariables.money_format);
      drawerSelectors.cartTotal.innerHTML = cartTotal;

      let cart_items_count = cartHTML.querySelector('[data-item-count]');
      if(cart_items_count) this.querySelector('[data-item-count]').innerHTML = cart_items_count.innerHTML;

      let elements = this.querySelectorAll('[data-checkoutBtns], [data-cartnote], [data-upselldiv]');
      let cart_container = this.querySelector('.cart-form-container');
      if(window.globalVariables.cart.item_count <= 0){
        elements.forEach((div)=>{
          div.classList.add('d-none');
        });
        cart_container.classList.add('empty_cart');
      }else{

        if(window.globalVariables.template == 'product'){
         
          let productPageId = window.globalVariables.product.id;
          if(document.querySelector(`#product-form-${productPageId} [data-qty-input]`)){
            if(window.globalVariables.cart.item_count > 0){
              let cartItems = window.globalVariables.cart.items;
              let checkForTotal = parseInt(document.querySelector(`#product-form-${productPageId} [data-qty-input]`).getAttribute('data-availableinventory'));
              let variantId = document.querySelector(`#product-form-${productPageId} input[name="id"]`).value;
              let getFQU = parseInt(document.querySelector(`#product-form-${productPageId} [data-qty-input]`).getAttribute('data-fqu'));

              let variantInventoryPolicy = document.querySelector('[data-variantinventorypolicyJSON]');
              let currentVariantInventoryPolicy = '';
              if (variantInventoryPolicy) {
                const scriptContent = variantInventoryPolicy.textContent || variantInventoryPolicy.innerText;
                const extractInventoryPolicy = new Function(`${scriptContent}; return variant_inventory_policy;`);
                const inventoryPolicyData = extractInventoryPolicy();
                if (inventoryPolicyData && inventoryPolicyData[variantId]) {
                  currentVariantInventoryPolicy = inventoryPolicyData[variantId];
                }
              }

              cartItems.forEach(item => {
                // console.log('item',item, currentVariantInventoryPolicy);
                if(parseInt(variantId) == parseInt(item.id)){
                  let fquTotal = getFQU + item.quantity;
                  if((fquTotal > checkForTotal) && currentVariantInventoryPolicy != 'continue'){
                    document.querySelector(`#product-form-${productPageId} [type="submit"]`).setAttribute('disabled',true);
                    document.querySelector(`#product-form-${productPageId} [data-for="increase"]`).setAttribute('disabled',true);
                    if(document.querySelector('.incart-errormsg')){
                      document.querySelector('.incart-errormsg').innerHTML = `<p class="fs-sm rounded text-danger">Please check product quantity in cart.</p>`;
                      document.querySelector('.incart-errormsg').classList.remove('d-none');
                    } 
                  }else{
                    document.querySelector(`#product-form-${productPageId} [data-for="increase"]`).removeAttribute('disabled');
                    document.querySelector(`#product-form-${productPageId} [type="submit"]`).removeAttribute('disabled');
                    document.querySelector(`#product-form-${productPageId} [type="submit"]`).classList.remove('disabled');

                    if(document.querySelector('.incart-errormsg')){
                      document.querySelector('.incart-errormsg').innerHTML = '';
                      document.querySelector('.incart-errormsg').classList.add('d-none');
                    } 
                  }
                }
              });
            }
          }
        }

        elements.forEach((div)=>{
          div.classList.remove('d-none');
        });
        cart_container.classList.remove('empty_cart');
      }
      if(window.globalVariables.customer_email != null){
        this.addLocationAttributes();
      }
      

      this.checkForAdditional();

      this.setAttribute('updating', false);

      let headerHTML = new DOMParser().parseFromString(response['header'], 'text/html');
      let cartIcon = headerHTML.getElementById('cart-icon-desktop');
      if(drawerSelectors.cartIconDesktop) drawerSelectors.cartIconDesktop.innerHTML = cartIcon.innerHTML;
      if(drawerSelectors.cartIconMobile) drawerSelectors.cartIconMobile.innerHTML = cartIcon.innerHTML;

      if(window.globalVariables.template !== 'cart' && window.globalVariables.templateSuffix !== 'quick-order' && window.globalVariables.cart_drawer && action === 'open_drawer'){
        this.openCartDrawer();
      }
    }

    /**
     * Fetch latest cart data 
     *
     * @param {string} action Open Drawer as value if need to Open Cart drawer or else let it be empty
     */
    getCartData(action){
      let cartRoute = `${window.location.pathname}?sections=${this.sectionID},header`;
      
      fetch(cartRoute).then(response => {
        return response.json();
      }).then(response => {
          this._updateCart(response, action);
      }).catch((e) => {
          console.error(e);
          // Rollbar.error(`File: component-cart-form.js, getting error on getCartData: ${e}`);
      }).finally(() => {
          // Cart HTML fetch done
      });
    }
  
     /**
     * Update Quantity API call 
     *
     * @param {string} line Line Index value of cart Item (Starts from 1)
     * @param {integer} quantity Quantity to update
     */
    updateItemQty(line, quantity){
      let lineItem = document.querySelectorAll('[data-cart-item]')[line-1];

      if(lineItem){ lineItem.classList.add('updating'); }
      const body = JSON.stringify({
        line,
        quantity,
        sections: `${this.sectionID},header`
      });

      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body }})
      .then((response) => {
          return response.text();
      })
      .then((_state) => {
        let dataJSON = ((typeof res == 'object') ? _state : JSON.parse(_state));
        if(dataJSON.errors){
          window.notificationEle.updateNotification('Cart Update', dataJSON.errors, {
            type: 'error',
            timeout: 5000
          });
        }
        this.checkForAdditional();
        this._updateCart(dataJSON.sections,null,'updateCart');

      }).catch((error) => {
        window.notificationEle.updateNotification('Cart Update', error, {
          type: 'error',
          timeout: 5000
        });
        window.Rollbar?.error(`File: component-cart-form.js, getting error on updateItemQty: ${error}`);
      }).finally(() => {
        setTimeout(() => {
          if(lineItem){ lineItem.classList.remove('updating'); }
        }, 500);
      });
    }
  
    /**
     * Remove Item Event
     *
     * @param {event} Event instance
     */
    removeItem(event){
      event.preventDefault();
      let currentTarget = event.currentTarget;
      let itemIndex = currentTarget.dataset.index || null;
      if(itemIndex !== null){
          this.updateItemQty(itemIndex, 0,'updateCart');
      }
    }
  
    /**
     * Cart Item Qunatity Increment/Decrement Button event
     *
     * @param {event} Event instance
     */
    manageQtyBtn(event){
      event.preventDefault();
      let currentTarget = event.currentTarget;
      let action = currentTarget.dataset.for || 'increase';
      let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
      let itemIndex = $qtyInput.dataset.index || 1;
      let variantInventoryPolicy = currentTarget.closest('[data-cart-item]').querySelector(`[data-variantinventorypolicyJSON]`);
      var variantId = currentTarget.closest('[data-cart-item]').getAttribute('data-variant-id');

      let currentVariantInventoryPolicy = '';
      if (variantInventoryPolicy) {
        const scriptContent = variantInventoryPolicy.textContent || variantInventoryPolicy.innerText;
        const extractInventoryPolicy = new Function(`${scriptContent}; return variant_inventory_policy;`);
        const inventoryPolicyData = extractInventoryPolicy();
        if (inventoryPolicyData && inventoryPolicyData[variantId]) {
          currentVariantInventoryPolicy = inventoryPolicyData[variantId];
        }
      }

      let stepQty = ($qtyInput.step) ? parseInt($qtyInput.step) : 1;
      if($qtyInput.getAttribute('data-inputcart-fqu')){
        stepQty = parseInt($qtyInput.getAttribute('data-inputcart-fqu'));
      }
      let minQty = ($qtyInput.min) ? parseInt($qtyInput.min) : 1;
      let maxQty = ($qtyInput.max) ? parseInt($qtyInput.max) : null;

      let currentQty = parseInt($qtyInput.value) || minQty;
      let finalQty = currentQty;

      let data_qty_bulk_number = 1;

      if($qtyInput.getAttribute('data-qty-bulk-number')){
        data_qty_bulk_number = parseInt($qtyInput.getAttribute('data-qty-bulk-number'));
      }
  
      if((action === 'decrease' || event.currentTarget.dataset.forBulk === 'decrease') && currentQty <= minQty && currentQty != stepQty){
        return false;
      }else if(action === 'decrease' || event.currentTarget.dataset.forBulk === 'decrease'){
        if(currentQty != stepQty){
          if (event.currentTarget.dataset.forBulk == 'decrease') {
            finalQty = currentQty - data_qty_bulk_number;
    
            // Ensure finalQty is a multiple of FQU
            finalQty = Math.round(finalQty / stepQty) * stepQty;
            finalQty = Math.max(finalQty, stepQty);
          } else {
            finalQty = currentQty - stepQty;
          }
        }else{
          return false;
        }
      }else{
        if (event.currentTarget.dataset.forBulk == 'increase') {
          finalQty = currentQty + data_qty_bulk_number;
  
          // Ensure finalQty is a multiple of FQU
          finalQty = Math.round(finalQty / stepQty) * stepQty;
          finalQty = Math.max(finalQty, stepQty);
        } else {
          finalQty = currentQty + stepQty;
        }
      }

      // Restrict Inventory
      let checkForUpdate = false;
      if($qtyInput.hasAttribute('data-inputcart-itemavailable')){
        // stepQty = UOM
        let totalQty = $qtyInput.getAttribute('data-inputcart-itemavailable') ? parseInt($qtyInput.getAttribute('data-inputcart-itemavailable')) : 1000;

        if((finalQty > totalQty) && currentVariantInventoryPolicy != 'continue'){
          checkForUpdate = true;
          window.notificationEle.updateNotification('Quantity Update', `You can not update quantity more than ${totalQty}.`, {
            type: 'error',
            timeout: 5000
          });
          // finalQty = currentQty - stepQty;
        }
      }



      if(checkForUpdate == false){
        if(currentTarget.closest('[data-upselldiv]') == null){
         
          this.updateItemQty(itemIndex, finalQty,'updateCart');
        }
      }
      
      // if(maxQty != null && finalQty <= maxQty && finalQty >= minQty){
      //   this.updateItemQty(itemIndex, finalQty);
      // }else if(finalQty >= minQty){ 
        
      // }
    }

    /**
     * Cart Item Qunatity Input change event
     *
     * @param {event} Event instance
     */
    onQtyChange(event){
      const $qtyInput = event.currentTarget;
      const qtyValue = $qtyInput.value;
      const itemIndex = $qtyInput.dataset.index || null;
      if(itemIndex) this.updateItemQty(itemIndex, qtyValue,'updateCart');
    }

    /**
     * Manage Cart Notes
     */
    cartNoteInput(){
      const cartNoteEle = document.querySelector('[data-cartNote] [name="note"]');
      if(!cartNoteEle) return;

      const cartNoteSave = document.querySelector('[data-saveNote]');
      let cartNoteEvents = ['input', 'paste'];
      cartNoteEvents.forEach((eventName)=>{
        cartNoteEle.addEventListener( eventName, (evt)=> {
          const defaultNote = cartNoteEle.dataset.default;
          if(defaultNote !== cartNoteEle.value){
            cartNoteSave.style.display = 'block';
          }else{
            cartNoteSave.style.display = 'none';
          }
        }, false);
      });

      //  Cart Note Change event
      cartNoteSave.addEventListener( "click", evt => {
        evt.preventDefault();
        const cartNoteContainer = evt.currentTarget.closest('[data-cartNote]');
        const cartNote = cartNoteContainer.querySelector('[name="note"]').value.trim();
        if(cartNote.length <= 0){
          alert('Add Note before proceeding');
          return;
        }
        
        const submitBtn = cartNoteContainer.querySelector('[data-saveNote]');
        const waitText = (submitBtn.dataset.adding_txt) ? submitBtn.dataset.adding_txt : 'Saving...';
        submitBtn.innerHTML = waitText;
        submitBtn.disabled = true;
        this.updateCartNote(cartNoteContainer);
      });
    }

    /**
     * Update Cart Note
     * @param {element} cartNoteContainer 
     */
    updateCartNote(cartNoteContainer){
      const _this = this;
      const cartNoteEle = cartNoteContainer.querySelector('[name="note"]');
      const cartNote = cartNoteEle.value.trim();
      const resultEle = cartNoteContainer.querySelector('[data-resultMsg]');
      const submitBtn = cartNoteContainer.querySelector('[data-saveNote]');
      const defaultText = (submitBtn.dataset.default) ? submitBtn.dataset.default : 'Save';

      let body = JSON.stringify({
        note: cartNote
      });
      fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body }
      }).then(function (data) {
        if (data.status === 200) {
          if(resultEle){
            resultEle.innerText = 'Added note to Order!';
            _this.manageResponseText(resultEle);
          }
          if(cartNoteEle){
            cartNoteEle.dataset.default = cartNote;
          }
          submitBtn.style.display = 'none';
          submitBtn.innerHTML = defaultText;
          submitBtn.disabled = false;
        }
        else {
          console.error('Request returned an error', data);
          if(resultEle){
            resultEle.innerText = data;
            _this.manageResponseText(resultEle);
          }
          submitBtn.innerHTML = defaultText;
          submitBtn.disabled = false;
        }
      }).catch(function (error) {
          console.error('Request failed', error);
          window.Rollbar?.error(`File: component-cart-form.js, getting error on updateCartNote: ${error}`);
          if(resultEle){
            // Guarding the Rollbar call above made the rest of this catch reachable for the
            // first time - so this line now renders to the shopper. The raw Error stays in
            // the console line above; the buyer gets something they can act on.
            resultEle.innerText = 'Could not save note. Please try again.';
            _this.manageResponseText(resultEle);
          }
          submitBtn.innerHTML = defaultText;
          submitBtn.disabled = false;
      });
    }

    /**
     * fade effect on reponse
     * @param {element} element 
     */
    manageResponseText(element){
      Utility.fadeEffect(element, 'fadeIn');
      setTimeout(() => {
          Utility.fadeEffect(element, 'fadeOut');
      }, 3000);
    }

    /**
     * Handle checkout button click
     * Saves websiteType to cart attributes and redirects to checkout
     * @param {event} event 
     */
    handleCheckoutClick(event) {
      event.preventDefault();
      const websiteType = Utility.getCookie('websiteType');

      // Save websiteType to cart attributes via Shopify API
      const formData = new FormData();
      formData.append('attributes[savecart]', websiteType);

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        // console.log('Cart attributes updated:', data);
        // Redirect to checkout
        window.location.href = window.routes.checkout_url || '/checkout';
      })
      .catch(error => {
        console.error('Error updating cart attributes:', error);
        // Still redirect to checkout even if attribute update fails
        window.location.href = window.routes.checkout_url || '/checkout';
      });
    }
  }
customElements.define("cart-form", AjaxCart);



 /* START :: savecart functionality to auto add products */
 